import { Controller } from "@hotwired/stimulus"

// Auto-submits a form after a debounce delay (500ms).
// Replicates the DHH/37signals live search pattern (HEY.com cmd+k).
// Restores focus to the search input after Turbo Frame reload.
//
// Usage:
//   <form data-controller="manage--search-debounce">
//     <input type="text" data-action="input->manage--search-debounce#search">
//   </form>
export default class extends Controller {
  static values = { delay: { type: Number, default: 500 } }

  connect() {
    this._timeout = null
    this.#restoreFocusIfNeeded()
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  search(event) {
    this.#saveFocusState(event.target)
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  #saveFocusState(input) {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return
    frame.dataset.searchFocusName = input.name
    frame.dataset.searchCursor = input.selectionStart ?? ""
  }

  #restoreFocusIfNeeded() {
    const frame = this.element.closest("turbo-frame")
    if (!frame || !frame.dataset.searchFocusName) return

    const name = frame.dataset.searchFocusName
    const cursor = parseInt(frame.dataset.searchCursor, 10)
    delete frame.dataset.searchFocusName
    delete frame.dataset.searchCursor

    // Solo restaurar foco en inputs de texto, no en selects
    const input = this.element.querySelector(`input[name="${name}"]`)
    if (!input) return

    input.focus()
    if (!isNaN(cursor) && input.setSelectionRange) {
      input.setSelectionRange(cursor, cursor)
    }
  }
}
